import React, {PropsWithChildren, useEffect, useState} from "react";
import {Popover, PopoverContent, PopoverTrigger, PopoverClose} from "@/components/ui/popover.tsx";
import {Button, ButtonProps} from "@/components/ui/button.tsx";

type Props = {
    onConfirm: () => void
    onCancel?: () => void
    confirmText?: string
    cancelText?: string
    message?: string
    body?:React.ReactNode
    confirmButtonVariant?: ButtonProps['variant']
    cancelButtonVariant?: ButtonProps['variant']
    buttonSize?: ButtonProps['size']
}

export function ConfirmPopover(props: PropsWithChildren<Props>) {

    const {
        onConfirm,
        onCancel,
        confirmText = 'אישור',
        cancelText = 'ביטול',
        message = 'האם אתה בטוח?',
        confirmButtonVariant = 'default',
        cancelButtonVariant = 'outline',
        buttonSize = 'sm',
        body,
        children
    } = props;

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if(!open) {
            onCancel && onCancel();
        }
    }, [open]);

    function handleConfirm() {
        setOpen(false);
        onConfirm();
    }

    return (
        <Popover open={open} onOpenChange={setOpen} modal={false}>
            <PopoverTrigger asChild onDoubleClick={handleConfirm}>
                {children}
            </PopoverTrigger>
            <PopoverContent>
                <div className="flex flex-col gap-2">
                    <p className="text-sm text-neutral-500 dark:text-neutral-400">{message}</p>
                    {body}
                    <div className="flex justify-end gap-2">
                        <PopoverClose asChild>
                            <Button
                                variant={cancelButtonVariant}
                                size={buttonSize}
                            >
                                {cancelText}

                            </Button>
                        </PopoverClose>
                        <Button
                            variant={confirmButtonVariant}
                            size={buttonSize}
                            onClick={handleConfirm}
                        >
                            {confirmText}
                        </Button>
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    )
}